import React, { Component } from 'react';
import ProgressCircle from '../../components/ProgressCircle';
import { connect } from 'react-redux';
import { Icon } from '@material-ui/core';
import { COLORS } from '../../styles';
import { leavePickWinnerMode } from '../../actions/TVModeAction';

const MONTHS = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

class TVModeOverlay extends Component {
  state = {
    progressValue: 0
  };

  lastHover = null;
  progressInterval = null;

  constructor() {
    super();
    this.onHover = this.onHover.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousemove', this.onHover);
  }

  componentWillUnmount() {
    this.props.leavePickWinnerMode();
    document.removeEventListener('mousemove', this.onHover);
  }

  onHover() {
    const now = Date.now();
    if (this.lastHover === null || now - this.lastHover > 250) {
      this.lastHover = now;
      const slide = document.getElementsByClassName('slide active')[0];
      const header = document.getElementById('tv-mode-header');

      if (slide) {
        slide.style.cursor = 'default';
        header.style.opacity = 1;

        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);

        this.hoverTimeout = setTimeout(() => {
          slide.style.cursor = 'none';
          header.style.opacity = 0;
        }, 2000);
      }
    }
  }

  clearProgress() {
    if (this.progressInterval) clearInterval(this.progressInterval);
  }

  startTrackingProgress() {
    const { ROTATION_INTERVAL } = this.props;
    this.setState({ progressValue: 0 }, () => {
      if (this.progressInterval) clearInterval(this.progressInterval);
      this.progressInterval = setInterval(() => {
        let progressValue = this.state.progressValue + 1;
        if (progressValue > 99) {
          this.setState({ progressValue: 0 });
        } else {
          this.setState({ progressValue });
        }
      }, ROTATION_INTERVAL / 100);
    });
  }

  render () {
    const { showWinnerButton, queue, reelStarted, alert, escapeTVMode, pickWinner, switchSlideOrPause } = this.props;
    const { winnerFound, progressValue } = this.state;

    let progressColor;
    if (queue && queue[0] && queue[0].key !== 'integration') progressColor = COLORS[Number(queue[0].key) % COLORS.length];
    else progressColor = 'white';

    let timestamp = queue && queue[0] && queue[0].props && queue[0].props.shoutout
      ? new Date(queue[0].props.shoutout.timestamp)
      : new Date();
    let time = timestamp.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).toLowerCase();
    let date = `${MONTHS[timestamp.getMonth()]} ${timestamp.getDate()}, ${timestamp.getFullYear()}`;

    //if (queue && queue[0]) console.log(queue[0].type.displayName);
    const footerClass = queue && queue[0] && queue[0].key === 'integration'
      ? 'tv-mode-footer integration-footer'
      : 'tv-mode-footer';

    return (
      <div>
        <div id="tv-mode-header">
          <div className="tv-mode-button-wrapper">
            <div onClick={() => escapeTVMode()} className="tv-mode-button tv-esc">
              Press <span style={{}}>ESC</span> to exit TV mode
            </div>
            <div onClick={() => pickWinner()} className="tv-mode-button tv-winner"
              style={{ display: showWinnerButton && !winnerFound ? 'block' : 'none' }}>
              Choose a winner
            </div>
          </div>
          <div onClick={() => escapeTVMode()} className="tv-mode-button tv-close">
            <Icon>close</Icon>
          </div>
        </div>
        <div className={footerClass} style={{ display: !alert.length ? 'flex' : 'none' }}>
          <div className="tv-mode-footer-date">
            {date}<br />
            {time}
          </div>
          <div className="tv-mode-footer-line"></div>
          <div className="tv-mode-progress">
            <ProgressCircle value={progressValue} fill={false} center={progressColor} visible={reelStarted} />
            <Icon style={{ opacity: reelStarted ? 0 : 1 }}
              onClick={() => switchSlideOrPause({ key: reelStarted ? '' : ' ' })}>
              play_arrow
            </Icon>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ tvModeStore, shoutoutsStore }) => {
  const { showWinnerButton, queue, alert } = tvModeStore;
  const { newShoutout } = shoutoutsStore;
  return { showWinnerButton, queue, newShoutout, alert };
};

export default connect(mapStateToProps, { leavePickWinnerMode }, null, { withRef: true })(TVModeOverlay);


// WEBPACK FOOTER //
// ./src/screens/tv/TVModeOverlay.js